export const COLUMN_GENERATION_EXPRESSION_INFORMATION: string = `Generation expression will be used to set default value to the column when the column is not present in the data. 
Example values are None, 0, 1, <variable> + <variable>. Please note that Nullable must be set to True when generation expression is set to None.`;

export const FIVE_MINUTES_IN_SECONDS = 300; //5 minutes

export const THREE_MINUTES_IN_MILLISECONDS = 180000; //3 minutes

export const DEALCARD_BASE_URL = '/api/deals';
